<script lang="ts">
  import { branches, selectedBranch } from '../../store'
  import { changeWikiBranch } from '../../services'
  import { getBranchSvg } from './helpers'
  import MobileWikiBranches from './components/MobileWikiBranches.svelte'

  const isMobile: boolean = screen.width <= 576
</script>

{#if $branches.length > 1 && $selectedBranch}
  {#if isMobile}
    <MobileWikiBranches />
    <!-- MobileWikiBranches — position: fixed (min-height 44px); резервируем место под него, как GlobalSearch в ленте (margin-top) -->
    <div class="mobile-spacer" />
  {:else}
    <div class="branches text-bold">
      {#each $branches as item (item.pk)}
        <div
          class="branch"
          style="border-bottom: {$selectedBranch.pk === item.pk ? `2px solid ${item.color}` : '2px solid transparent'}"
          style:color={$selectedBranch.pk === item.pk ? '#5A5F6D' : 'rgba(90, 95, 109, 0.6)'}
          on:click={() => changeWikiBranch(item)}
        >
          <div class="icon" class:selected={$selectedBranch.pk === item.pk}>
            {@html getBranchSvg(item.color)}
          </div>

          <div>{item.title}</div>
        </div>
      {/each}
    </div>
  {/if}
{/if}

<style>
  .mobile-spacer {
    height: 44px;
    margin-bottom: 16px;
  }

  .branches {
    display: flex;
    margin-bottom: 16px;
  }

  .branch {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding-bottom: 18px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 3px;
    transition: all .2s;
  }

  .icon {
    margin-right: 4px;
    display: flex;
    opacity: .2;
  }

  .icon.selected {
    opacity: 1;
  }
</style>
